export default {
  title: 'Region',
  NAOnlyMessage: 'Please set your area code. This will be used for local dialing.',
  MultiWithNAMessage: 'Please set the country and area code for your region. This will be used for local dialing and phone number formatting.',
  MultiWithoutNAMessage: 'Please select the country you locate in. This will be used for local dialing and phone number formatting.',
  country: 'Country',
  areaCode: 'Area Code',
  areaCodePlaceholder: 'Enter Area Code',
};
